import { Loader } from '@googlemaps/js-api-loader'
import { MarkerClusterer, SuperClusterAlgorithm } from '@googlemaps/markerclusterer'

const loader = new Loader({
  apiKey: window.CANZ?.mapsApiKey,
  version: 'quarterly',
})

// Interface used by lost-pet-listings component
export default {
  init,
  update,
}

var map = null
var infoWindow = null
var clusterer = null
var oms = null
var currentRegionId = null
const allNZ = {
  center: { lat: -40.8, lng: 172 },
  zoom: 5,
}

// Called from init and lost-pet-listings component
// when the markers or region data is refreshed
function update(updates) {
  updateMarkers(updates.markers)
  updateRegion(updates.region)
}

const updateMarkers = (markers) => {
  if (!map || !markers) { return }

  if (oms) {
    oms.clearMarkers()
  }

  const mapMarkers = markers.map((m) => {
    const marker = new google.maps.Marker({
      map,
      position: m.position,
      icon: m.icon.url,
    })

    // markers can only be keyboard focusable when they have click listeners
    // open info window when marker is clicked, close when same marker clicked
    marker.addListener('click', () => {
      const sameContent = infoWindow.getContent() === m.infoWindowContent
      if (sameContent) {
        infoWindow.close()
        infoWindow.setContent('')
      } else {
        infoWindow.setContent(m.infoWindowContent)
        infoWindow.open(map, marker)
      }
    })

    if (oms) {
      oms.addMarker(marker)
    }

    return marker
  })

  if (clusterer) {
    clusterer.clearMarkers()
    clusterer.addMarkers(mapMarkers)
  }
}

const updateRegion = (newRegionId) => {
  // All of nz region comes through as ""
  // so this catch clause prevents null or undefined
  if (!map || newRegionId == null) { return }

  // Don't pan if the region isn't changing
  if (currentRegionId === newRegionId) { return }

  currentRegionId = newRegionId
  const regDetails = window.CANZ?.regions.find((reg) => reg.value == newRegionId) ?? allNZ
  map.panTo(regDetails.center)
  map.setZoom(regDetails.zoom)
}

async function init() {
  await loader.load()
  // Request needed libraries.
  await google.maps.importLibrary('maps')

  map = new google.maps.Map(document.getElementById('map'), {
    zoom: allNZ.zoom,
    center: allNZ.center,
    minZoom: 5,
    maxZoom: 19,
    styles: [
      {
        // Hide Points Of Interest to make map less noisy
        featureType: 'poi',
        stylers: [{ visibility: 'off' }],
      },
    ],
  })

  infoWindow = new google.maps.InfoWindow({
    content: '',
    // offset infowindow so it visually sits nicely on top of our marker
    pixelOffset: {
      width: 0,
      height: -5,
    },
    maxWidth: 250,
  })

  // Clear infowindow content on close. This works with closing infowindow
  // on marker click (see updateMarkers function)
  infoWindow.addListener('closeclick', () => {
    infoWindow.setContent('')
  })

  map.addListener('zoom_changed', () => {
    infoWindow.setContent('')
    infoWindow.close()
  })

  // Add a marker clusterer to manage the markers.
  const algorithm = new SuperClusterAlgorithm({ maxZoom: 15 })
  clusterer = new MarkerClusterer({ markers: [], map, algorithm })

  // Spiderfy markers that are too close together
  const options = {
    legWeight: 3,
    minZoomLevel: 15,
    keepSpiderfied: true,
    spiderfiedShadowColor: 'grey',
    nudgeStackedMarkers: false,
    markersWontMove: true,
    markersWontHide: true,
  }
  const Spiderfier = require('overlapping-marker-spiderfier')
  oms = new Spiderfier(map, options)
}
